"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
// Eslint doesn't know how to handle the Map from Immutable.
/* eslint-disable functional/prefer-readonly-type */
const ts_pattern_1 = require("ts-pattern");
const reducer_1 = require("../cart/reducer");
const reducer_2 = require("../deprecated/contactUsForm/reducer");
const reducer_3 = require("../deprecated/minicart/reducer");
const reducer_4 = require("../deprecated/navigation/reducer");
const reducer_5 = require("../deprecated/partnerWithUs/reducer");
const reducer_6 = require("../locale/reducer");
const reducer_7 = require("../packages/reducer");
const reducer_8 = require("../products/reducer");
const reducer_9 = require("../promotions/reducer");
const reducer_10 = require("../ukPoliceData/reducer");
/**
 * This uses ts-pattern under the hood, which is a pattern matching library for typescript that is a valid TS type-guard.
 * https://github.com/gvergnaud/ts-pattern
 */
const reducer = (state, action) => (0, ts_pattern_1.match)(action)
    .with({ '@@type': 'cart' }, (0, reducer_1.cartReducer)(state))
    .with({ '@@type': 'package' }, (0, reducer_7.packagesReducer)(state))
    .with({ '@@type': 'contactUsForm' }, (0, reducer_2.contactUsFormReducer)(state))
    .with({ '@@type': 'partnerWithUs' }, (0, reducer_5.partnerWithUsFormReducer)(state))
    .with({ '@@type': 'minicart' }, (0, reducer_3.minicartReducer)(state))
    .with({ '@@type': 'navigation' }, (0, reducer_4.navigationReducer)(state))
    .with({ '@@type': 'ukPoliceData' }, (0, reducer_10.ukPoliceDataReducer)(state))
    .with({ '@@type': 'locale' }, (0, reducer_6.localeReducer)(state))
    .with({ '@@type': 'product' }, (0, reducer_8.productsReducer)(state))
    .with({ '@@type': 'promotion' }, (0, reducer_9.promotionReducer)(state))
    .with({ 'type': '@@redux/INIT' }, () => state)
    .when(_action => _action.type.includes('@@redux'), () => state)
    .with({ 'type': '@@INIT' }, () => state)
    .exhaustive();
exports.reducer = reducer;
//# sourceMappingURL=reducer.js.map